module.exports = __webpack_public_path__ + "img/cup.1b1ba6a0.png";